import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleAssignTagRequest(
  project: Identifiable<Project>,
  { assignableId, tag }: Boundaries["assignTag"]["request"],
): Identifiable<Project> {
  return project.uuid === assignableId
    ? {
        ...project,
        tags: project.tags ? [...project.tags, tag] : [tag],
      }
    : project;
}

function handleAssignTagSuccess(
  project: Identifiable<Project>,
  { assignableId, tag }: Boundaries["assignTag"]["success"],
): Identifiable<Project> {
  if (project.uuid !== assignableId) return project;

  const index = project.tags.findIndex(({ name }) => name === tag.name);

  return project.uuid === assignableId
    ? {
        ...project,
        tags: project.tags
          ? index !== -1
            ? [
                ...project.tags.slice(0, index),
                tag,
                ...project.tags.slice(index + 1),
              ]
            : [...project.tags, tag]
          : [tag],
      }
    : project;
}

function handleAssignTagFailure(
  project: Identifiable<Project>,
  { assignableId, tag }: Boundaries["assignTag"]["failure"],
): Identifiable<Project> {
  return project.uuid === assignableId
    ? {
        ...project,
        tags: project.tags.filter(({ name }) => name !== tag.name),
      }
    : project;
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
